<!-- Call Header -->
<app-pathway-call-header
  [isLoading]="isLoading()"
  [title]="title"
  [showCallDetails]="shouldShowCallDetails"
  [callDetails]="callDetails()"
  (settingsClicked)="handleSettingsClick()"
  (leaveStepClicked)="handleLeaveStepClick()"
  (callDetailsModalOpened)="handleCallDetailsModalOpened()"
>
</app-pathway-call-header>

<!-- Call Main Content -->
@if (mainIsLoading()) {
  <div class="loading-overlay">
    <qai-loading size="large" />
  </div>
} @else if (isShowingResults()) {
  <app-call-roleplay-results />
} @else {
  @if (isPreamble()) {
    <app-call-preamble
      [captionsOn]="footerService.captionsOn()"
      [captionText]="captionText()"
      [callDetails]="callDetails()"
    />
  } @else {
    <app-call-roleplay-content
      [controlService]="controlService"
      [realtimeService]="realtimeService"
      [callStore]="callStore"
      [playerService]="playerService"
      [deviceSettingsService]="deviceSettingsService"
      [hideUserVideo]="isPreamble() && stepType !== 'QUIZ'"
    />
  }
}

<!-- Pause modal -->
@if (controlService && callStore?.getIsPaused() && !deviceSettingsService?.displayModal && !controlService.isEndCallTriggered) {
  <app-call-pause
    [control]="controlService"
    [player]="playerService"
    [deviceSettings]="deviceSettingsService"
  />
}

<!-- Call Footer -->
<app-roleplay-call-footer
  (launchSimulationClicked)="handleLaunchSimulationClick()"
  (resultActionClicked)="handleResultActionClick()"
  (endCallClicked)="handleOnConfirmActionClick()"
/>